import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

/**
 * interfaces
 */
import { IFacilityDto } from '../interfaces';

/**
 * services
 */
import { FacilityService } from '../services';

/**
 * Route resolver for the Facility page.
 * Fetches facility data before the component activates so the component
 * receives a ready-to-use DTO via ActivatedRoute.snapshot.data['facility'].
 */
export const facilityResolver: ResolveFn<IFacilityDto> = () => {
    const _facilityService = inject(FacilityService);
    return _facilityService.getFacility();
};
